module.exports = __webpack_public_path__ + "static/media/celebration-stars.010cd31c.svg";